import api from "./api.js";

const ModuleService = {

    getModuleByProjectId(projectId){
        return  api.get(`/api/modules/byProjectId/${projectId}`)
    }

}
export default ModuleService;